import styled from 'styled-components';
import { ReactComponent as Success } from "../../assets/images/success.svg"

export const Container = styled.div`
  flex: 1;
  width: 100%;
  height: 100vh;
  background-color: ${({ theme }) => theme.colors.white};
`;

export const Content = styled.main`
  padding: 1rem;
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;

  align-items: center;
  background-color: ${({ theme }) => theme.colors.white};
  @media (min-width: 724px) {
    padding-top: 3rem
  }

  @media (min-height: 600px) {
    height: 100%;
  }
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  margin-top: 13.813rem;
  z-index: 20; 
  max-width: 40rem;

  @media (min-width: 724px) {
    margin-top: 4rem;
    text-align: center;
  }
`

export const IconContainer = styled.div`
  position: absolute;
  left: -6.125rem;
  top: 4.875rem;
  z-index: 10;

  @media (min-width: 724px) {
    position: static;
    margin-top: 4rem;
  }
`

export const Icon = styled(Success)`
  width: 292px;
  
  @media (min-width: 724px) {
    width: 290px;
  }
`

export const FooterContainer = styled.div`
  display: flex;  
  align-items: center;
  justify-content: center;
  padding: 2rem;
  border-top: 1px solid ${({ theme }) => theme.colors.gray400};
  width: 100%;
  background-color: ${({ theme }) => theme.colors.white};
`

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
  width: 1280px;
  @media (min-width: 724px) {
    flex-direction: row;
  }
`